@if (settingsMenuItems | settingsMenuItemPerms | async; as settingsMenuItems) {
  <app-settings-group-page
    [icon]="'swap_horiz'"
    [settingsMenuPageTitle]="integrationsMenuItemTitle"
    [settingsMenuPageItems]="settingsMenuItems">
  </app-settings-group-page>
}
